'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('test', {
                parent: 'entity',
                url: '/test',
                data: {
                    roles: ['ROLE_ADMIN', 'ROLE_COURSE_DEVELOPER'],
                    pageTitle: 'lmsApp.test.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/test/test.html',
                        controller: 'TestController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('test');
                        return $translate.refresh();
                    }]
                }
            })
            .state('testDetail', {
                parent: 'entity',
                url: '/test/:id',
                data: {
                    roles: ['ROLE_ADMIN', 'ROLE_COURSE_DEVELOPER'],
                    pageTitle: 'lmsApp.test.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/test/test-detail.html',
                        controller: 'TestDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('test');
                        return $translate.refresh();
                    }]
                }
            });
    });
